import { post, get, deletefn, putfun } from './http.js'
export default {
  // 网站信息
  async webInfo (params) {
    return await get ('/common/system-config',params)
  },
  // 地理信息
  async regionInfo (params) {
    return await get ('/common/region',params)
  },
  // 首页列表
  async home_data (data) {
    return await get ('/common/home',data)
  },
  // 轮播图
  async slideList (params) {
    return await get ('/common/slide',params)
  },
  // 广告详情
  async advertDetail (params) {
    return await get (`/common/page/${params}`)
  },
  // 最新视频拉取
  async getNewVideo (params) {
    return await get ('/course',params)
  },
  // 最新职位
  async getNewJob (params) {
    return await post ('/job',params)
  },

  // 底部导航列表
  async getPageTab (params) {
    return await get ('/common/page',params)
  },
  // 单页面详情
  async pageDetail (params) {
    return await get (`/common/page/${params}`)
  },
  // 收藏
  async getUserCollect (params) {
    return await post ('/common/collects',params)
  },
  // 点赞
  async getUserLike (params) {
    return await post ('/common/likes',params)
  },
  // 关注
  async getFollow (params) {
    return await post ('/common/follow',params)
  },
  // 系统标签
  async systemTag (params) {
    return await get ('/common/system-tag',params)
  },
  // 推荐设计师
  async recUser (params) {
    return await get ('/rec-users',params)
  },
  //  服务商列表
  async supplierList (params) {
    return await get ('/common/service-provider',params)
  },

  // 服务商详情
  async supplierDetail(params) {
    return  await get (`/common/service-provider/${params}`)
  },

  // 服务商分类
  async supplierCategory(params) {
    return  await get ("/common/service-provider-category",params)
  },

  // 搜索
  async search(params) {
    return  await get ('/common/search',params)
  },
  // 搜索统计
  async searchCount(params) {
    return  await get ('/common/search-count',params)
  },
  // 举报
  async report(params) {
    return  await post ('/common/report',params)
  },
  // 跳转小程序
  async wx_url(params) {
    return  await post ('/common/third-page',params)
  },
  // 名师列表
  async teacher_rec(params) {
    return  await get ('/teacher',params)
  },
  // 名师详情
  async teacher_detail(params) {
    return  await get (`/teacher/${params}`)
  },
  // 名师详情 视频列表
  async teacher_detail_video(params) {
    return  await get (`/course`,params)
  },
}



// WEBPACK FOOTER //
// ./src/request/index.js